import { uuidSchema as e } from "../common/index.js";
import { notificationChannelSchema as t, notificationConditionSchema as n, notificationInstantSchema as r, notificationOutcomeSchema as i, notificationResponseStateSchema as a, notificationStepSchema as o, notificationStepStateSchema as s, notificationTargetSchema as c } from "./notification.schema.js";
import * as l from "zod";
// src/notifications/notification-response.schema.ts
var u = l.number().int().nonnegative(), d = l.string().min(1).max(500), f = l.strictObject({
	id: e,
	name: d
}), p = l.strictObject({
	responseId: e.optional(),
	cursor: l.string().min(1).max(2e3).optional(),
	limit: l.union([l.string().regex(/^[0-9]+$/), l.number()]).pipe(l.coerce.number().int().min(1).max(100)).default(50)
}), m = l.strictObject({
	recipientCount: u,
	acceptedCount: u,
	deliveredCount: u,
	failedCount: u,
	unknownCount: u
}), h = l.enum([
	"cancelled",
	"condition-skipped",
	"edit-skipped",
	"unavailable",
	"uncovered",
	"empty",
	"missing-channel",
	"exhausted",
	"unknown",
	"failed",
	"complete",
	"superseded",
	"stopped",
	"removed"
]), g = l.strictObject({
	kind: l.literal("configured"),
	key: l.string().max(160),
	id: e,
	step: o,
	targetName: d,
	dueAt: r,
	state: s,
	appliedRevision: u.min(1),
	outcome: i.nullable(),
	reasons: l.array(h).max(14),
	counts: m
}), _ = l.strictObject({
	kind: l.literal("authorized"),
	key: l.string().max(160),
	stepId: e,
	stableStepId: e,
	position: u.nullable(),
	dueAt: r.nullable(),
	target: c,
	targetName: d,
	condition: n.nullable(),
	authorizingRevision: u.min(1),
	channel: t,
	authorizedAt: r,
	lastObservedAt: r.nullable(),
	attemptCount: u,
	reasons: l.array(h).max(14),
	counts: m
}), v = l.discriminatedUnion("kind", [g, _]), y = l.strictObject({
	id: e,
	policy: f,
	team: f,
	configuredStepCount: u,
	counts: m,
	assignmentGeneration: u.min(1),
	originalReceipt: r,
	enrolledAt: r,
	enrolledRevision: u.min(1),
	appliedRevision: u.min(1),
	state: a,
	outcome: i.nullable(),
	finishedAt: r.nullable(),
	nextDueAt: r.nullable(),
	stepsLoaded: l.boolean(),
	steps: l.array(v).max(100),
	nextCursor: l.string().max(2e3).nullable()
}), b = l.strictObject({
	incidentId: e,
	incidentStatus: l.enum([
		"open",
		"acknowledged",
		"resolved"
	]),
	latestEnrollment: l.strictObject({
		assignmentGeneration: u.min(1),
		team: f.nullable(),
		enrolledAt: r,
		outcome: l.enum([
			"no-team",
			"no-enabled-policy",
			"enrolled"
		])
	}).nullable(),
	items: l.array(y).max(100),
	nextCursor: l.string().max(2e3).nullable()
});
export { y as incidentNotificationBindingSchema, b as incidentNotificationResponsePageSchema, p as incidentNotificationResponseQuerySchema, m as notificationProgressCountsSchema, h as notificationProgressReasonSchema, v as notificationResponseEntrySchema };

//# sourceMappingURL=notification-response.schema.js.map